<template>
  <div
    class="
      py-1
      lg:py-6
      text-2xl
      lg:text-6xl
      font-display
      text-amff-white
      bg-amff-black
      whitespace-nowrap
      overflow-x-hidden
      select-none
    "
    aria-hidden="true"
  >
    <div class="-ml-36 lg:-ml-96">
      <template v-for="i in 10" :key="i">Music.Talks.Movies.</template>
    </div>
  </div>
</template>
